import {Col, Row} from "react-bootstrap";
import Footer from "./footer";
import NavBar from "./navbar";

export default function PolicyComponent() {
    return (
        <Col style={{padding: 0}}>
            <NavBar/>
            <div style={{padding: "5% 10%", fontFamily: "Circular Std Book, sans-serif"}}>
                <Row className="title-text"
                     style={{fontSize: "23px", fontWeight: "200", display: "flex", justifyContent: "center"}}>Политика
                    конфидицильности</Row>
                <Row className="text"
                     style={{marginTop: "25px", backgroundColor: "#181A26", padding: "20px 20px", fontSize: "14px"}}>
                    <div>
                        Используя наш сайт (далее — Сайт), вы безоговорочно принимаете данное Пользовательское
                        Соглашение (далее — Соглашение). В случае несогласия с любыми положениями Соглашения, вы
                        обязуетесь в срочном порядке покинуть наш сайт.
                    </div>
                    <div style={{marginTop: "20px"}}>
                        Сайт является рекламной площадкой исключительно для взрослых людей, достигшим совершеннолетия.
                        Просим обратить внимание, что на сайте могут быть размещены материалы эротического
                        характера(фото или видео), которые противоречат вашему моральному устрою, или могут быть
                        оскорбительными. В данном случае мы рекомендуем покинуть Сайт немедленно!
                    </div>
                    <div style={{marginTop: "20px"}}>
                        <div style={{color: "white", fontSize: "16px"}}>Отказ от ответственности</div>
                        Администрация не размещает и не редактирует никакую информацию, связанную с анкетами девушек!
                        Сайт работает в автономном режиме. Все анкеты созданы на добровольной основе пользователями
                        сайта, без премодерации. Администрация сайта не несет ответственность за информацию или
                        медиафайлы размещенные пользователями!
                    </div>
                    <div style={{marginTop: "20px"}}>
                        <div style={{color: "white", fontSize: "16px"}}>Запрещено:</div>
                        Регистрация на сайте и в последствии создание анкет лицам не достигшим совершеннолетия!
                        Упоминать, размещать, агитировать сторонние порталы и ресурсы конкурентов.
                        Использование украденных фотографий и видео из различных открытых источников(соц.сети, средства
                        массовой информации и тд.)
                        Размещение на сайте материалов(фото и видео) порнографического характера.
                        Фотографии с неприкрытыми половыми органами(разрешено использование блюра)
                        Создание анкет-клонов, с целью увеличить кол-во просмотров.
                        Выдавать себя за человека из администрации сайта.
                        Создавать анкеты с целью мошенничества.
                        Раскрывать личности пользователей сайта(настоящие имена, адреса, серии паспортов и тд.)
                    </div>
                </Row>
            </div>
            <Footer/>
        </Col>
    )
}